import axios from "axios";
import historytab from '../../custom_lib/AiCharts/historytab.vue';
import Percentagechart from "../../custom_lib/AiCharts/statisticalval.vue"
import D3PieChart from "../../custom_lib/AiCharts/D3PieChart.vue";
import stackedbarchart from '../../custom_lib/AiCharts/StackedBarchart.vue';
import histogram from '../../custom_lib/AiCharts/histogram.vue';
import advtable from '../../custom_lib/AiCharts/advenenttable.vue';
import groupbarchart from '../../custom_lib/AiCharts/groupbarchart.vue';
import chartdrill from '../../custom_lib/AiCharts/popupfiles/chartdrillPopup.vue';
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';
import store from "@/store";
export default{
  name: "demographicReport",
  props: {

  },
  components:{
    historytab,
    Percentagechart,
    D3PieChart,
    stackedbarchart,
    histogram,
    advtable,
    groupbarchart,
    chartdrill
  },
  data() {
     return{
        data :[],
        baseapi:process.env.VUE_APP_Service_URL,
        baseUrl: process.env.VUE_APP_Service_URL + "/forms-ml/report/",
        totalCount: 0,
        datahistory:[],
        historykeys:[],
        historydata:{},
        drilldata:{},
        drilldowndata:[],
        drillpopup:false,
        arrayofkeys: [
          "USUBJID", "BRTHDTC", "AGE", "AGEU", "SEX", "RACE", "RACEOTH", "COUNTRY", "MARITAL", "SMOKE", "ALCOHOL", "BMI", "COMORB", "DIET", "EXERFREQ", "HLTHSTAT", "MEDIC"
        ],
        xaxiskeys:{"groupbarchart":"",
          "barchart":"",
          "histogram":"",
          "piechart":"AGE",
          "advtable":"",
          "aepiechart":"",
          "historytab":"",
          "chartdrill":""},
        groupchartkeys:{
          "xaxiskey":"SEX",
          "groupkey":"",
        },
        loader:true,
        studyId:"",
        interimVersion:""
     };
  },
  async mounted(){
    this.studyId = store.getters.getStudyIs;
    await this.getVersion()
    await this.getdata();
    
    window.addEventListener("studyIdChanged", async () => {
      this.studyId = store.getters.getStudyIs;
      await this.getVersion()
      await this.getdata();
      
   })
  },
  methods: {
     async getVersion(){
      const idtoken = store.getters.getIdToken;
        await axios.get(
        `${this.baseapi}/forms/cdisc/listauditsdtm?StudyId=${this.studyId}`,
        {
          headers: {
            Authorization: `Bearer ${idtoken}`,
            "Content-Type": "application/json",
          },
        }
      ).then((res)=>{
        this.versionList = res.data.entities.filter(entity => entity.interimVersion !== null && entity.interimVersion !== "");
      }).catch((err)=>{
        console.log("err",err)
      })
    },
    async setVersionNo(){
      await this.getdata();
    },
    exporttopdf() {
      // Create a temporary container
      const pdfContainer = document.createElement('div');
      const pdfContainer1 = document.createElement('div');
      const pdfContainer2 = document.createElement('div');
      const pdfContainer3 = document.createElement('div');
      const pdfContainer4 = document.createElement('div');
      const pdfContainer5 = document.createElement('div');

      const captureArea1 = document.getElementById('percentagediv').cloneNode(true);
      const captureArea2 = document.getElementById('scatteredploat').cloneNode(true);
      const captureArea3 =  document.getElementById('piechartdiv').cloneNode(true);
      const captureArea4 =  document.getElementById('histogramdiv').cloneNode(true);
      const captureArea5 =  document.getElementById('groupchartdiv').cloneNode(true);

      captureArea2.classList.add('page-break');
      captureArea3.classList.add('page-break');
      captureArea4.classList.add('page-break');
      captureArea5.classList.add('page-break');
      // Append cloned elements to the container
      pdfContainer1.appendChild(captureArea1);
      pdfContainer2.appendChild(captureArea2);
      pdfContainer3.appendChild(captureArea3);
      pdfContainer4.appendChild(captureArea4);
      pdfContainer5.appendChild(captureArea5);
      
      // Optionally style the container for PDF formatting
     
      pdfContainer1.style.width = '100%';
      pdfContainer2.style.width = '100%';
      pdfContainer3.style.width = '100%';
      pdfContainer4.style.width = '100%';
      pdfContainer5.style.width = '100%';
      pdfContainer.appendChild(pdfContainer1);
      pdfContainer.appendChild(pdfContainer2);
      pdfContainer.appendChild(pdfContainer3);
      pdfContainer.appendChild(pdfContainer4);
      pdfContainer.appendChild(pdfContainer5);

      pdfContainer.style.display = 'block';
      // Set the options for html2pdf
      const opt = {
        margin: 0,
        filename: 'Demographics Summary.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' }
      };
    
      // Convert the temporary container to PDF
      html2pdf().set(opt).from(pdfContainer).save();
     },
    async exporttoexcell() {
      const worksheet = XLSX.utils.json_to_sheet(this.data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "Demographics Summary.xlsx");
    },
    async retaingroupchartvars(groupvars){
      if(groupvars.xaxiskey!="" && groupvars.groupkey!=""){
      this.groupchartkeys = groupvars;
      }
    },
    async getdata() {
        this.loader= true;
        const filters = [
          {
            operation: "=",
            field: "StudyId",
            value: this.studyId
          },
          {
            operation: "=",
            field: "InterimVersion",
            value: this.interimVersion
          }
        ];
        
        await axios.post(
          `${this.baseUrl}getallreports?table_name=DM`, { filters })
          .then((res) => {
            this.data = res.data;
            this.totalCount = res.data.length;
            this.loader= false;
            this.datahistory.push(this.data);
            this.historydata['Home'] = this.data;
            if(!this.historykeys.includes('Home')){
                this.historykeys.push('Home');
            }
          })
          .catch((err) => console.log("error in screen list", err));
      },
    async drillpopupopened(datafromchild) {
        this.drilldata = datafromchild;
        this.drillpopup = true;  
    },
    async drilldowncurrentchart(datafromchild){
      this.data = datafromchild;
      this.datahistory.push(this.data);
    },
    async drilldowncurrentchartforbar(datafromchild){
      console.log("sorteddataforbarchart",datafromchild);
      const lastkey = this.historykeys[this.historykeys.length - 1];
      // this.data = datafromchild.sortedData;
      if(this.historydata[lastkey].length != datafromchild.sortedData.length){
      // if(!this.historykeys.includes(datafromchild.filterkeyword)){
       this.historykeys.push(datafromchild.filterkeyword);
      this.historydata[datafromchild.filterkeyword] = datafromchild.sortedData;
      this.data = this.historydata[datafromchild.filterkeyword];
      }
    },
    async gotohistorylevel(history){
      this.deleteAfterKeyvaluearrays(history);
      this.deleteAfterKeyarrays(history);
      this.data = this.historydata[history];
    },
    async deleteAfterKeyvaluearrays(selectedKey) {
      const entries = Object.entries(this.historydata); // Convert the object to an array of entries
      const selectedIndex = entries.findIndex(([key, value]) => key === selectedKey);
    
      // If the key is found, slice the array to keep only the entries up to the selected key
      const newEntries = selectedIndex !== -1 ? entries.slice(0, selectedIndex + 1) : entries;
    
      // Convert the array of entries back into an object
      return Object.fromEntries(newEntries);
    },
    async deleteAfterKeyarrays(selectedKey) {

      let index = this.historykeys.indexOf(selectedKey);

if (index !== -1) {
    // Slice the array up to the element (including the element)
    this.historykeys = this.historykeys.slice(0, index + 1);
}
    },
    async retainxaxiskey(xaxiskey){
      if(xaxiskey!=""){
      this.xaxiskeys["piechart"] = xaxiskey;
      }
    },
      async onclosed(){
        this.drillpopup = false;
      },
      async pageclosed(){
        this.$router.push(`/analyticalDashboard`);
      }
  },
};